import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { saveOrder } from '../services/orderService';

const scrollToTop = () => {
  window.scrollTo(0, 0);
};

const CheckoutPaymentOption = ({
  data,
  completeOrder,
  changeInfo,
  handleNotification,
  emptyCart,
  props,
}) => {
  const [isProcessing, setProcessing] = useState(false);
  const [payMethod, setPayMethod] = useState('credit card');

  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (payMethod === 'credit card') {
      setProcessing(true);

      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: 'card',
        card: elements.getElement(CardElement),
        billing_details: {
          name: data.name,
          email: data.email,
          phone: data.phone,
          address: {
            line1: data.address,
            city: data.city,
            postal_code: data.postalCode,
          },
        },
      });

      if (error) setProcessing(false);

      if (!error) {
        setProcessing(true);
        const order = await completeOrder();

        if (!order) setProcessing(false);

        if (order) {
          order.paymentMethod = 'credit card';
          const { id } = paymentMethod;
          order.paymentId = id;

          try {
            const { data } = await saveOrder(order);


            // console.log(data.payment.charges.data[0].payment_method_details.card)
            handleNotification({
              message: 'Order placed successfully!',
              img: '/img/success.png',
            });

            emptyCart();
            props.history.push('/dashboard/orders/order/' + data.order._id);
          } catch (error) {
            console.log(error);
          }
        }
      }
    } else if (payMethod === 'cod') {
      setProcessing(true);

      const order = await completeOrder();

      if (!order) setProcessing(false);

      if (order) {
        order.paymentMethod = 'cod';

        try {
          const { data } = await saveOrder(order);

          handleNotification({
            message: 'Order placed successfully!',
            img: '/img/success.png',
          });

          emptyCart();
          props.history.push('/dashboard/orders/order/' + data.order._id);
        } catch (error) {
          console.log(error);
        }
      }
    }
  };

  return (
    <div className='payment-block'>
      {scrollToTop()}
      <br />
      <div className='checkout-final-info'>
        <div className='row'>
          <div className='col-sm-2'>
            <p>
              <span>Contact</span>
            </p>
          </div>
          <div className='col-sm-8'>
            <p>{data.email}</p>
          </div>
          <div className='col-sm-2'>
            <p className='changee' onClick={changeInfo}>
              Change
            </p>
          </div>
        </div>

        <div className='liney'></div>

        <div className='row'>
          <div className='col-sm-2'>
            <p>
              <span>Ship to</span>
            </p>
          </div>
          <div className='col-sm-8'>
            <p>
              {data.address}, {data.city} {data.postalCode}, {data.country}
            </p>
          </div>
          <div className='col-sm-2'>
            <p className='changee' onClick={changeInfo}>
              Change
            </p>
          </div>
        </div>
      </div>

      <h4>Payment method</h4>

      <div className='accordion payment-option' id='accordionExample'>
        <div className='card'>
          <div className='payment-btn-header' id='headingOne'>
            <h2 className='mb-0'>
              <button
                className='btn payment-btns btn-block text-left'
                type='button'
                data-toggle='collapse'
                data-target='#collapseOne'
                aria-expanded='true'
                aria-controls='collapseOne'
                onClick={() => setPayMethod('credit card')}
                value='credit card'
              >
                <input
                  type='radio'
                  onChange={() => setPayMethod('credit card')}
                  value='credit card'
                  checked={payMethod === 'credit card'}
                />{' '}
                Credit card
              </button>
            </h2>
          </div>

          <div
            id='collapseOne'
            className='collapse show'
            aria-labelledby='headingOne'
            data-parent='#accordionExample'
          >
            <div className='card-body'>
              <p>Enter card information</p>
              <br />

              <CardElement
                options={{
                  iconStyle: 'solid',
                  hidePostalCode: true,
                  style: {
                    base: {
                      fontSize: '15px',
                    },
                  },
                }}
              />
            </div>
          </div>
        </div>

        <div className='card'>
          <div className='payment-btn-header' id='headingTwo'>
            <h2 className='mb-0'>
              <button
                className='btn payment-btns btn-block text-left collapsed'
                type='button'
                data-toggle='collapse'
                data-target='#collapseTwo'
                aria-expanded='false'
                aria-controls='collapseTwo'
                onClick={() => setPayMethod('cod')}
                value='cod'
              >
                <input
                  type='radio'
                  onChange={() => setPayMethod('cod')}
                  value='cod'
                  checked={payMethod === 'cod'}
                />{' '}
                Cash on Delivery
              </button>
            </h2>
          </div>
          <div
            id='collapseTwo'
            className='collapse'
            aria-labelledby='headingTwo'
            data-parent='#accordionExample'
          >
            <div className='card-body'>
              After clicking “Cash on Delivery”, your order will be placed. Pay
              at doorstep when you recieve your shipment.
            </div>
          </div>
        </div>
      </div>

      <br />
      <div className='checkout-left-block-btns'>
        <Link to='/products'>
          <button className='checkout-back-btn'>
            <i className='fas fa-angle-double-left'></i> Return to shop
          </button>
        </Link>

        <button
          className='continue-to-shipping'
          // onClick={completeOrder}
          onClick={handleSubmit}
          disabled={isProcessing}
        >
          {!isProcessing ? (
            'Complete order'
          ) : (
            <span>
              Processing... <i className='fas fa-circle-notch'></i>
            </span>
          )}
        </button>
      </div>
    </div>
  );
};

export default CheckoutPaymentOption;
